import Header from '../../site/components/Header';
import SlimFooter from '../../site/components/SlimFooter';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Spinner,
  Flex,
  Container,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import axios from '../../axiosConfig';
import ArticleReadPage from './ArticleReadPage';

const ArticlePublicView = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const res = await axios.get(`/articles/${slug}`);
        setArticle(res.data);
      } catch (err) {
        console.error('Failed to fetch article', err);
      } finally {
        setLoading(false);
      }
    };
    fetchArticle();
  }, [slug]);

  if (loading) {
    return (
      <Flex justify="center" align="center" minH="50vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Flex direction="column" minH="100vh" pt="70px">
      <Box w="100%" h="10px" bgGradient="linear(to-r, #A2BA06, #4EB9C5, #E5923B)" />
      <Header />

      <Container flex="1" maxW="container.lg" py={12} px={4}>
        <ArticleReadPage article={article} />
      </Container>

      <SlimFooter />
    </Flex>
  );
};

export default ArticlePublicView;
